var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-btn-root noselect",class:{
        'primary-color': _vm.color === 'primary',
        'secondary-color': _vm.color === 'secondary',
        disabled: _vm.disabled,
    },on:{"click":_vm.handleClick}},[_c('BaseIcon',{attrs:{"name":_vm.name,"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }